import React from 'react'
import Link from 'gatsby-link'

import Hero from '../../components/Hero'
import ProductCard from '../../components/ProductCard'
import LazyLoad from '../../components/LazyLoad'

import heroImg from '../../images/category/transient_recorders.png'

import { productsData } from '../../data/products-data'

const heroData = {
    heroTitle: [
        `transient`,
        `recorders`
    ],
    heroImg,
    heroDescHtml: `Precision measurement of torque, angle, load cell, and pressure is provided in the Standard MC900.It is a valuable tool for fastener enineers to study threaded fastener joint designs or they can analyze the operation of nut-runners on the plant floor and in a labratory environment.`,
    breadcrumbs: {
        text: 'home',
        link: '/',

        path: {
            text: 'transient recorders',
            link: 'transient-recorders'
        }
    }
}

const productList = productsData.filter(data => data.category.toLowerCase() === heroData.breadcrumbs.path.text.toLowerCase())

const TransientRecorders = () => (
    <div className='o-sub'>
        <Hero heroData={heroData} />
        <div className='o-container'>
            <LazyLoad>
                <div className={`c-products-list ${productList[0] && productList[0].items.length >= 2 ? '' : 'c-products-list--simple'}`}>
                    { productList[0] &&
                        productList[0].items.map((product, i) =>
                            <div className='c-products-list__item' key={i}>
                                <ProductCard product={product} />
                            </div>
                        )
                    }
                </div>
            </LazyLoad>
        </div>

    </div>
)

export default TransientRecorders



// WEBPACK FOOTER //
// ./src/pages/transient-recorders/index.jsx